import React from 'react'
import { Route, Switch } from 'react-router-dom'
import InServiceCont from '../../components/Operations/Transport/InService/InServiceCont'
import TransportCont from '../../components/Operations/Transport/Management/TransportCont'
import AddDWGCont from '../../components/Operations/Engineering/DWG/AddDWG/AddDWGCont'
import DWG from '../../components/Operations/Engineering/DWG/DWGCont'
import TaskSystemCont from '../../components/Operations/TaskSystem/TaskSystemCont'
import AddTaskSystemCont from '../../components/Operations/TaskSystem/AddTaskSystem/AddTaskSystemCont'
import NoMatchComponent from '../../components/NoMatch'
import AddQCCont from '../../components/Operations/Engineering/QC/AddQC/AddQCCont'
import QC from '../../components/Operations/Engineering/QC/QCCont'

export default function ClientRouter(props) {
  const url = props.match.url
  return (
    <Switch>
      <Route path={`${url}/engineering/dwg/:key/update`} component={AddDWGCont} />
      <Route path={`${url}/engineering/dwg/new`} component={AddDWGCont} />
      <Route path={`${url}/engineering/dwg`} component={DWG} />

      <Route path={`${url}/engineering/qc/:key/update`} component={AddQCCont} />
      <Route path={`${url}/engineering/qc/new`} component={AddQCCont} />
      <Route path={`${url}/engineering/qc`} component={QC} />

      <Route path={`${url}/transport/in-service`} component={InServiceCont} />
      <Route path={`${url}/transport/management`} component={TransportCont} />

      <Route path={`${url}/task-system/:key/update`} component={AddTaskSystemCont} />
      <Route path={`${url}/task-system/new`} component={AddTaskSystemCont} />
      <Route path={`${url}/task-system`} component={TaskSystemCont} />

      <Route component={NoMatchComponent} />
    </Switch>
  )
}
